import $ from 'jquery';
import EmblaCarousel from 'embla-carousel';

export default class TasksCarousel {
    constructor() {
        this.rootEl = $('#js-tasks-container');
        this.carouselEl = $('#js-tasks-carousel');
        this.carousel = null;
        this.prevControl = $(`[data-carousel-control="prev"]`, this.rootEl);
        this.nextControl = $(`[data-carousel-control="next"]`, this.rootEl);

        this.prevControl.on('click', () => this.carousel?.scrollPrev());
        this.nextControl.on('click', () => this.carousel?.scrollNext());
    }

    handleSlidesInView = carousel => {
        const canNext = carousel.canScrollNext();
        const canPrev = carousel.canScrollPrev();

        this.nextControl.prop('disabled', !canNext);
        this.prevControl.prop('disabled', !canPrev);
    }

    init() {
        if (this.carouselEl.length && !this.carousel) {
            this.carousel = EmblaCarousel(this.carouselEl.get(0), {
                loop: false,
                align: 'start',
                breakpoints: {
                  '(min-width: 1450px)': { active: false }
                }
            });

            this.carousel.on('slidesInView', this.handleSlidesInView)
        }

        return this;
    }
}